import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AuthWrapperComponent } from '@shared/auth-wrapper/auth-wrapper.component';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, FormsModule, AuthWrapperComponent]
})
export class ForgotPasswordComponent implements OnInit {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.authService.redirectIfAuthenticated('/forgot-password');
    }

    async sendPasswordResetEmail(form: NgForm): Promise<void> {
        if (form.invalid) {
            return;
        }
        await this.authService.sendPasswordResetEmail(form.value.resetEmail);
    }

    onCancel(event: Event): void {
        event.preventDefault();
        this.router.navigate(['/login']);
    }
}
